﻿let $ = require('jquery');
let SizerBreakpoint = require('../../SizerBreakpoint');

$('.jnf-widget.jnf-widget-menu-2:not(.simplified)').each(function (menuIndex, menuElement) {
	let $menuElement = $(menuElement);

	new SizerBreakpoint({
		element: $menuElement
	});
});